var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',[_c('el-col',[_c('div',{staticClass:"footer base-bg bbs-third-color"},[_c('div',[_c('a',{staticClass:"info-link",attrs:{"href":"","target":"_blank"}},[_vm._v("做自己想做的人")])]),_c('div',[_c('a',{staticClass:"info-link",attrs:{"href":"","target":"_blank"}},[_vm._v("生命不要求我们做最好的,只要求我们做最大的努力")])])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }